import styled from "@emotion/styled"
import { colorContrastLow, spacingStaticLg } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "src/components"

export const CustomerFeedbackSkeleton = () => (
	<>
		<BorderWrapper>
			<Skeleton.Text />
		</BorderWrapper>
		<ContentSkeleton />
	</>
)

const BorderWrapper = styled.div`
	margin: 0 0 ${spacingStaticLg};
	padding: 0 0 ${spacingStaticLg};
	border-bottom: 1px solid ${colorContrastLow};
`

const ContentSkeleton = styled(Skeleton)`
	height: 12vh;
`
